import React, { useMemo, useEffect } from "react";
import _ from "lodash";

import { SideNavigation } from "@toddle-edu/ds-web";

import {
  getInitialParentNodesCount,
  getSideNavigationOptions,
} from "./modules/Utils";
import classes from "./DatasetSideNavigation.scss";
import { getResolvedMinimalTreeSet } from "AppComponents/DatasetTaggingBody/modules/Utils";

const styles = {
  sideNavigationContainerStyle: {
    height: "100%",
    flex: "0 0 auto",
    width: "240px",
  },
};

const DatasetSideNavigation = props => {
  const {
    sideNavigationTab,
    handleOptionClick,
    testId,
    rootNodes,
    resolvedMinimalTree,
    resolvedValue,
    parentNodesCount,
    setParentNodesCount,
    plannerElementType,
  } = props;
  const sideNavigationOptions = useMemo(
    () => getSideNavigationOptions({ rootNodes, parentNodesCount }),
    [rootNodes, parentNodesCount]
  );

  // this is required as resolvedMinimalTree has different children values in case of pyp atls, causing reInitialization
  // deletedNodes are also present in children, but its not present in newQuery children, hence causing a cache update for resolvedMinimalTree
  const resolvedMinimalTreeHash = _.join(
    _.map(
      getResolvedMinimalTreeSet({ resolvedMinimalTree, plannerElementType }),
      "id"
    ),
    "|"
  );

  useEffect(() => {
    const parentNodesCount = getInitialParentNodesCount({
      resolvedMinimalTree,
      selectedRows: resolvedValue,
      plannerElementType,
    });
    setParentNodesCount(parentNodesCount);
  }, [resolvedMinimalTreeHash, resolvedValue, plannerElementType]);

  if (_.size(sideNavigationOptions) < 3) return null;

  return (
    <div className={classes.container}>
      <SideNavigation
        dsVersion="2.0"
        options={sideNavigationOptions}
        selectedOptionKey={sideNavigationTab}
        containerStyle={styles.sideNavigationContainerStyle}
        onClick={handleOptionClick}
        testId={testId}
      />
    </div>
  );
};

export default DatasetSideNavigation;
